import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const limitNotifications = 20

const getNotificationsByUid = async ({ uid, startAfterTimestamp }) => {
	if (!uid) {
		throw errorOfType(errorTypes.KEYNOTSPECIFIED, 'getNotificationsByUid')
	}
	try {
		const query = firestore.collection('userProfiles').doc(uid).collection('notifications').orderBy('createdTimestamp', 'desc')
		const notificationsQuerySnap = await (startAfterTimestamp ? query.startAfter(startAfterTimestamp) : query.limit(limitNotifications)).get()
		const notifications = notificationsQuerySnap.docs.map(nqs => nqs.data())

		return { notifications }
	} catch (exception) {
		console.log('exception', exception)
		throw errorOfType(errorTypes.UNKNOWNERROR, uid, exception)
	}
}

export default getNotificationsByUid



// WEBPACK FOOTER //
// ./src/dataservices/getNotificationsByUid.js